import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

// Create a global instance of the useToast hook
const toast = useToast({
    position: "top-right"
});

export default toast;